// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__F6ZJW","circle":"NotFound_circle__CGT9G","numbers":"NotFound_numbers__h8jfy","sorryText":"NotFound_sorryText__btyU5","text":"NotFound_text__bfi9K"};